const raw = window.APP_CONFIG;

// Rechaza no-valores, no solo falsy. El generador puede emitir el string
// "undefined" o dejar un placeholder sin sustituir, y ambos pasarían un !v.
const invalid = (v) =>
    typeof v !== 'string' ||
    v === '' ||
    v === 'undefined' ||
    v === 'null' ||
    v.includes('${');

// No lanza: src/index.js se evalúa después de todos sus imports transitivos,
// así que un throw acá impediría que la pantalla de error llegue a renderizar.
export const configError =
    !raw || typeof raw !== 'object' ? "No se pudo cargar /config.js"
        : invalid(raw.eid)          ? "Falta 'eid' en /config.js"
        : invalid(raw.apiBaseUrl)   ? "Falta 'apiBaseUrl' en /config.js"
        : null;

const apiBaseUrl = raw?.apiBaseUrl?.replace(/\/+$/, "");

const config = {
    aprName:     raw?.appName || "Nombre APR por defecto",
    aprEid:      raw?.eid,
    aprLogo:     raw?.logo || "/logo.snap.png",
    aprFavicon:  raw?.favicon || "/favicon.ico",
    // El API sirve el logo de cada tenant en /logo/<eid>.png.
    aprIcon:     `${apiBaseUrl}/logo/${raw?.eid}.png`,
    // Prefijo, no URL: los consumidores le concatenan ?nrut=...
    webpayUrl:   raw?.webpayUrl?.replace(/[?&/]+$/, ""),
    unitMeasure: raw?.unitMeasure || "m³",
    // Los 20 sitios de consumo concatenan /api/sucursal-virtual/...
    apiBaseUrl,
};

export default config;
